module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "con01"
    }
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "cover_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "title_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])])])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#ch01"
    }
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02#ch02"
    }
  }, [_vm._v("Chapter Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter03#ch03"
    }
  }, [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter04#ch04"
    }
  }, [_vm._v("Chapter Four")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_15"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_16"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_17"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_18"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_19"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_20"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_21"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_22"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_23"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_24"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Four")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_25"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Five")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_26"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Six")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_27"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Seven")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_28"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Eight")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_29"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Nine")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_30"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_31"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-One")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_32"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_33"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_34"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Four")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_35"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Five")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_36"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Six")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_37"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Seven")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_38"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Eight")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_39"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Nine")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_40"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_41"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-One")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_42"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_43"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter43#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_44"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter44#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Four")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_45"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter45#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Five")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ack_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgments#ack01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "insight_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/insight#insight01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P.S. Insights, Interviews & More ...")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "abtauth_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/abtauthor#abtauth01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "abtbook_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/abtbook#abtbook01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Book")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "readon_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/readon01#readon01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt: The Kindness of Strangers")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "readon_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/readon02#readon02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More by Katrina Kittle")])])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "alsoby_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/alsoby#alsoby01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Katrina Kittle")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "praise_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/praise01#praise01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for The Kindness of Strangers")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "praise_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/praise02#praise02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for Two Truths and a Lie")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "praise_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/praise03#praise03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for Traveling Light")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "copy_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/copyright#copy01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/atp01#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faf4820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0